import Vue from 'vue';
import SightMapVisitorFlowModeBtn from '@/components/SightMapVisitorFlowModeBtn';

export default class SettingControl {
  onAdd(map) {
    this._map = map;
    this._container = document.createElement('div');
    this._container.classList.add('mapboxgl-ctrl-visitor-flow-toggle');
    this._vueComponent = new Vue({
      //pass store to vm
      store: this._map.$vm.$store,
      render: h => h(SightMapVisitorFlowModeBtn)
    }).$mount();
    this._container.appendChild(this._vueComponent.$el);
    return this._container;
  }

  onRemove() {
    this._container.parentNode.removeChild(this._container);
    this._vueComponent = undefined;
    this._map = undefined;
  }
}